<template>
  <div>
    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Gösterim Sayısı</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>sonuç</label>
          </b-col>
        </b-row>
      </div>

      <b-table
        ref="refUserListTable"
        class="position-relative"
        :items="fetchEvents"
        responsive
        :fields="tableColumns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="Sonuç bulunamadı"
        :sort-desc.sync="isSortDirDesc"
      >
        <template #cell(influencer)="data">
          <template v-if="data.item.influencer && data.item.influencer.id">
            <influencer-link-btn :id="data.item.influencer.id" :name="data.item.influencer.username" />
          </template>
          <template v-else>
            <p>Bilinmeyen Fenomen</p>
          </template>
        </template>

        <template #cell(link)="data">
          <campaign-link-btn :name="data.item.link.campaign_name.replace(data.item.influencer.username+'-','')" :route="getLinkName(data.item.link)" />
        </template>

        <template #cell(total_vat)="data">
          {{ data.item.total_vat }} {{ data.item.store_currency }}
        </template>

        <template #cell(show_details)="data">
          <!-- Changed to open modal instead of toggle details -->
          <div @click="openHourlyModal(data.item)" style="cursor: pointer;">
            <FeatherIcon icon="ClockIcon"></FeatherIcon>
            Saatlik Bilgi
          </div>
        </template>

        <template #cell(page_url)="data">
          <a :href="data.item.page_url" target="_blank">     
            {{ data.item.page_url.length > 50 ? data.item.page_url.substring(0, 50) + "..." : data.item.page_url }}
          </a>
        </template>

        <template #cell(type)="data">
            <b> {{ getTypeName(data.item.link.type) }}</b> 
        </template>

        <template #cell(platform)="data">
            <b> {{ data.item.platform.name }}</b> 
        </template>

        <template #cell(created_date)="data">
          {{ formatDate(data.item.created_date) }}
        </template>

        <template #cell(created_time)="data">
          {{ formatDateTime(data.item.created_date) }}
        </template>
      </b-table>
      <div class="mx-2 mb-2">
        <b-row>

          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >

            <b-pagination
              v-model="currentPage"
              :total-rows="totalEvents"
              :per-page="perPage" 
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>

          </b-col>

        </b-row>
      </div>
    </b-card>

    <!-- Modal for Hourly Information -->
    <b-modal
      id="hourly-info-modal"
      :title="'Saatlik Bilgiler'"
      size="xl"
      centered
      hide-footer
      v-model="hourlyModal"
      @hidden="handleModalHidden"
    >
      <hourly-event :link_id="selectedLinkId" :title="modalTitle"></hourly-event>
    </b-modal>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BFormCheckbox, BTableLite, BModal
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import CampaignLinkBtn from '@/components/link/CampaignLinkBtn.vue'
import useEventsList from '@/components/event/useEventsList'
import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'
import HourlyEvent from '@/components/event/HourlyEvent.vue' // Import the hourly component

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormCheckbox,
    BTableLite,
    BModal,
    vSelect,
    CampaignLinkBtn,
    InfluencerLinkBtn,
    HourlyEvent // Register the hourly component
  },
  
  methods: {
    getLinkName(item) {
      let route = {
        name: '',
        params: {
          id: item.id
        }
      };

      if (item.type == 0) {
        if (item.links && item.links.length > 0) {
          route.name = "campaign-group-detail";
          route.params.id = item.group_id;
        } else {
          route.name = "campaign-detail";
        }
      } else if (item.type == 1) {
        route.name = "bio-story-detail";
      } else if (item.type == 2) {
        route.name = "bio-sms-detail";
      } else if (item.type == 3) {
        route.name = "bio-detail";
        route.params.platform_id = item.platform_id;
      }

      return route;
    },
    isGroupItem(item){
      return item.links && item.links.length > 0
    },
    getTypeName(type) {
      switch(type) {
        case 0:
          return 'Link Paylaşımı';
        case 1:
          return 'Story Paylaşımı';
        case 2:
          return 'SMS Paylaşımı';
        case 3:
          return 'Bio Paylaşımı';
        case 4:
          return 'Whatsapp Paylaşımı';
        default:
          return 'Bilinmeyen Tür';
      }
    }
  },
  setup() {
    const {
      fetchEvents,
      tableColumns,
      perPage,
      currentPage,
      totalEvents,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveEventstatusVariant,
    } = useEventsList()

    const selectedLinkId = ref(null)
    const modalTitle = ref('null')
    const hourlyModal = ref(false)

    // Function to open modal with selected link ID
    const openHourlyModal = (item) => {
      if (item.link && item.link.id) {
        modalTitle.value=item.link.campaign_name
        selectedLinkId.value = item.link.id
        hourlyModal.value = true
      } else {
        // Handle case where link ID is not available
        console.error('Link ID not available')
      }
    }
    

    // Function to handle modal hidden event
    const handleModalHidden = () => {
      hourlyModal.value = false
    }

    return {
      fetchEvents,
      tableColumns,
      perPage,
      currentPage,
      totalEvents,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refUserListTable,
      refetchData,
      hourlyModal,
      modalTitle,
      
      // Filter
      avatarText,
      
      // UI
      resolveUserRoleVariant,
      resolveUserRoleIcon,
      resolveEventstatusVariant,
      
      // New properties for modal
      selectedLinkId,
      openHourlyModal,
      handleModalHidden
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>